
export default {
  methods: {
    handleReload: function handleReload() {
      console.log('emittttt');
      this.$emit('reload');
    }
  }
};